module.exports = __webpack_public_path__ + "static/media/codepen.77efadfd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/codepen.png
// module id = 83
// module chunks = 0